<template>
  <div>
    <div class="topNavContainer">
      <nav class="w3-bar fixed-top w3-large topNav">
        <button @click="goHome()" class="w3-bar-item w3-padding-16 logo" style="max-height:58px; background:none;">
          <!-- <span class="logo1">Daytona</span><span class="logo2">Local</span> -->
          <img alt="Daytona Local Logo" aria-label="Logo link to home page" src="../assets/logo2.png" style="height:40px; margin:-4px 0 0 0" />
        </button>
        <button class="toggleMenu w3-bar-item w3-button w3-padding-16 w3-right" type="button" aria-label="open menu button" @click="toggleSidebar()">
            <font-awesome-icon icon="bars" class="w3-text-white" aria-hidden="true"></font-awesome-icon>
        </button>
      </nav>
    </div>
    <div class="topPadding"></div>
  </div>
</template>

<script>
export default {
  name: 'siteHeader',
  props: {
    msg: String
  },
  methods: {
    toggleSidebar() {
      if (document.getElementById("appSidebar").style.display === "none" || !document.getElementById("appSidebar").style.display) {
        document.getElementById("appSidebar").style.display = "block";
      } else if (document.getElementById("appSidebar").style.display = "block") {
        document.getElementById("appSidebar").style.display = "none";
      }
    },
    goHome() {
      this.$router.push('/')
      window.scrollTo(0,0)
    }
  }
}
</script>

<style scoped>
  .w3-bar {background: #424242; z-index: 1;}
  .w3-bar .logo {color: #fff; text-decoration: none;}
  .logo1 {font-weight:bold; margin-left:10px;}
  .logo2 {color:#86C232}
  .nav-item > a {color: #fafafa;}
</style>
